import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { FileInfo } from '../models/file-info';

export const mediaActions = createActionGroup({
    source: 'Media',
    events: {
        'Get File': props<{ id: string }>(),
        'Get File Success': props<{ id: string; fileInfo: FileInfo }>(),
        'Get File Error': props<{ id: string }>(),

        Clear: emptyProps(),
    },
});
